import { Alert, Typography } from '@mui/material';
import { OctagonWarningContainedIcon } from '@ankr.com/ui';

import { useIsUserSuspended } from 'modules/accountStatus/hooks/useIsUserSuspended';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { suspendedUserAlertTranslation } from './translation';
import { useSuspendedUserAlertStyles } from './useSuspendedUserAlertStyles';

export interface SuspendedUserAlertProps {
  className?: string;
}

export const SuspendedUserAlert = ({ className }: SuspendedUserAlertProps) => {
  const isSuspended = useIsUserSuspended();

  const { keys, t } = useTranslation(suspendedUserAlertTranslation);

  const { classes } = useSuspendedUserAlertStyles();

  if (!isSuspended) {
    return null;
  }

  return (
    <Alert
      className={className}
      classes={classes}
      icon={<OctagonWarningContainedIcon />}
      severity="error"
    >
      <Typography color="textPrimary" variant="body3">
        {t(keys.message)}
      </Typography>
    </Alert>
  );
};
